// extracted by mini-css-extract-plugin
module.exports = {"root":"BillActions_root__4mvwQ","actionBtn":"BillActions_actionBtn__vvYxd","actionBtnLabel":"BillActions_actionBtnLabel__OsPD9"};